<template>
  <div
    v-show="showFAQ"
    class="chatbot-container"
  >
    <div
      v-show="loading"
      class="full chatbot-loading-mask"
    />
    <div class="chatbot-body">
      <span
        class="close-btn"
        @click="toggleFAQ(false)"
      >
        <i class="isif isif-close" />
      </span>
      <template v-for="(item, index) in data">
        <button
          :key="item.id"
          @click="sendQuestionHandler(item, index)"
        >
          {{ item.question }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { sendQuestion } from '@/api/instantMessaging'
import { Loading } from 'element-ui'

export default {
  name: 'InstantMessagingChatbot',

  props: {
    data: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters([
      'user',
      'property',
      'currentBuilding',
      'qaList',
      'currentConversationId',
      'showFAQ'
    ])
  },

  methods: {
    ...mapActions([
      'toggleFAQ'
    ]),
    sendQuestionHandler (faq, index) {
      this.loading = true
      const loadingInstance = Loading.service({ target: '.chatbot-loading-mask', fullscreen: false })
      sendQuestion(this.currentConversationId, faq.id, index)
        .then(() => {})
        .catch(error => console.log(error))
        .finally(() => {
          loadingInstance.close()
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.chatbot-container {
  border-radius: 5px
  width: 100%
  height: 125px
  background-color: $white
  overflow-y: scroll
  position: absolute
  left: 0
  bottom: 0
}

.chatbot-body {
  width: 100%
  display: flex
  justify-content: space-around
  align-items: center
  flex-wrap: wrap
  padding: 30px 8px 8px 8px

  & > button {
    font-size: 1rem
    padding: 2px 8px
    border-radius: 5px
    margin-right: 6px
    margin-bottom: 16px
    box-shadow: 2px 2px 5px 0 rgba(163, 163, 163, 0.5)
    user-select none

    &:active {
      box-shadow: inset 2px 2px 5px 0 rgba(163, 163, 163, 0.5)
    }
  }
}

.close-btn {
  position: absolute
  top: 0
  right: 0
  width: 24px
  height: 24px
  display: flex
  justify-content: center
  align-items: center
  text-shadow: none
  color: $black
  cursor: pointer
}

.loading-mask {
  position: absolute
  top: 0
  left: 0
  display: flex
  justify-content: center
  align-items: center
  background-color #fff
}
</style>
